import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import { Icon, Spinner, Button, generateQeId } from '@ctct/ui-react';

import GetPromoInput from './GetPromoInput';
import { useInboxPreviewContext } from './InboxPreviewContext';

const propTypes = {
  addPromo: PropTypes.func.isRequired,
  removePromo: PropTypes.func.isRequired,
};

const PromoCodeControl = ({ addPromo, removePromo }) => {
  const { t } = useTranslation();

  const [state, dispatch] = useInboxPreviewContext();
  const { selectedAddDiscount, promoDescription, removingPromo, promoCode, showAddedPromo, qeId } = state;

  return showAddedPromo ? (
    <div style={{ paddingBottom: 15, paddingLeft: 23 }}>
      <span data-qe-id={generateQeId(qeId, 'discount-value')}>
        {removingPromo ? (
          <span style={{ paddingRight: 4 }}>
            <Spinner size="small" className="remove-discount-icon" />
          </span>
        ) : (
          <Icon
            data-qe-id={generateQeId(qeId, 'clear-discount-code')}
            className="close-discount remove-discount-icon"
            onClick={removePromo}
            glyph="closeCircle"
          />
        )}{' '}
        <span
          className={classNames('order-summary-discount-label', 'order-summary-body-left')}
          data-qe-id={generateQeId(qeId, 'discount-code')}
        >
          <Trans
            i18nKey="add-inbox-preview.discount-code"
            values={{ discountCode: promoCode, discountDescription: promoDescription }}
          >
            <b>error</b>
          </Trans>
        </span>
      </span>
    </div>
  ) : (
    <div style={{ maxWidth: 350, fontSize: 12, paddingBottom: 10 }}>
      <div data-qe-id="inbox-preview-add-a-discount">
        <Button
          text={t('add-inbox-preview.has-discount')}
          kind="link"
          className="order-summary-discount-button"
          onClick={() => {
            dispatch({ type: 'setSelectedAddDiscount', value: !selectedAddDiscount });
          }}
        />
      </div>
      {selectedAddDiscount && (
        <div className="order-summary-section-row order-summary-discount-input-wrapper">
          <div className="sidebar-accordion-panel">
            <GetPromoInput addPromo={addPromo} />
          </div>
        </div>
      )}
    </div>
  );
};

// PromoCodeControl.defaultProps = defaultProps;
PromoCodeControl.propTypes = propTypes;

export default PromoCodeControl;
